/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */
import React, { useState, useContext, useEffect } from 'react';
import { Button, Col, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import CreditPolicyDetailContext from './CreditPolicyDetailContext';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  cellDateOperation,
  cellNumOperation,
  cellOperation,
  headerDoubleRowOperation,
  headerOperation
} from '../../../helpers/tables';
import { API, BASE_URL, } from '../../../CONST';
import { fileDownload, tipoEndosoLabels } from '../../../helpers/helpers';
import FormSection from '../../layout/FormSection';
import BaseTable from '../../shared/BaseTable';
import { vigenciasToOptions } from '../../../helpers/selects';


const CreditPolicyDetailVigencias = ({policy, loginIdToken, initialVigencia}) => {
  const { endosos, borrador } = policy;
  let emittedEndosos = endosos.filter(e => e.emitido);

  if (borrador === null) {
    emittedEndosos = emittedEndosos.filter(endoso => endoso.vigencia === null);
  }

  const getInitialEndoso = () => {
    if (initialVigencia !== undefined && initialVigencia !== null) {
      const matchingEndoso = emittedEndosos.find(e => e.numero_vigencia === initialVigencia);
      if (matchingEndoso) return matchingEndoso;
    }
    return emittedEndosos[0];
  };

  const [ selectedVigencia, setSelectedVigencia ] = useState(getInitialEndoso());


  const vigenciasOptions = vigenciasToOptions(emittedEndosos);
  const selectedVigenciaOption = vigenciasOptions.find(opt => opt.value.id === selectedVigencia.id);

  const endososModificacion = emittedEndosos.filter(endoso =>
    endoso.numero_vigencia === selectedVigencia.numero_vigencia
  ).sort((a, b) => a.secuencia_endoso - b.secuencia_endoso);

  const { setCurrentEndoso } = useContext(CreditPolicyDetailContext);

  useEffect(() => {
    setCurrentEndoso(endososModificacion[endososModificacion.length - 1]);
  }, [endososModificacion, setCurrentEndoso])

  const columns = [
    {
      Header: headerOperation('Movimiento'),
      id: 'movimiento',
      accessor: i => cellOperation(`${i.secuencia_endoso} - ${tipoEndosoLabels[i.tipo]}`),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Emisión'),
      id: 'emision',
      accessor: i => cellDateOperation(i.fecha_emision),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Inicio', 'Cobertura'),
      id: 'inicio-vigencia-endoso',
      accessor: i => cellDateOperation(i.inicio_vigencia_endoso),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Fin', 'Cobertura'),
      id: 'termino-vigencia',
      accessor: i => cellDateOperation(i.termino_vigencia),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Moneda'),
      id: 'moneda',
      accessor: () => cellOperation(policy.base.moneda_asegurada.nombre_corto),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Estimación', 'de Ventas'),
      id: 'estimacion-ventas-amt',
      accessor: i => cellNumOperation(i.estimacion_ventas_amt),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Tasa Costo', 'Seguro (%)'),
      id: 'tasa_costo_seguro',
      accessor: i => cellOperation(`${i.tasa_costo_seguro_defecto_pct}%`),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Prima Neta', 'Estimada'),
      id: 'prima-minima-anual',
      accessor: i => cellNumOperation(i.prima_minima_anual_amt, 'float'),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Plazo Máximo', 'Crédito'),
      id: 'plazo-maximo-credito-dias',
      accessor: i => cellNumOperation(i.plazo_maximo_credito_dias),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Acciones'),
      id: 'acciones',
      accessor: i => cellOperation((
        <div
          style={{
            padding: '0 25%',
          }}
        >
          <Button
            title="Descargar PDF"
            className="form-values download"
            onClick={() => fileDownload(
              `${BASE_URL}${API.fullCreditos}/${policy.id}/download-endoso/?endoso=${i.id}`,
              loginIdToken,
              )}
          >
            <FontAwesomeIcon icon={faDownload} />
          </Button>
        </div>
      )),
      filterable: false,
      sortable: false,
    }
  ];

  return (
    <Col md={{ offset: 2, size: 8 }}>
      <FormSection title="Resumen Movimientos">
        <FormGroup>
          <label htmlFor="vigencia">
            Vigencia
          </label>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '50% max-content max-content',
              gridGap: '10px',
            }}
          >
            <Select
              id="vigencia"
              name="vigencia"
              className="orsan-form-element"
              value={selectedVigenciaOption}
              onChange={selectedOption => setSelectedVigencia(selectedOption.value)}
              options={vigenciasOptions}
            />
          </div>
        </FormGroup>
        {selectedVigencia && (
          <BaseTable
            columns={columns}
            data={endososModificacion.sort((a, b) => a.secuencia_endoso - b.secuencia_endoso)}
            id={selectedVigencia.id}
          />
        )}
      </FormSection>
    </Col>
  );
};


CreditPolicyDetailVigencias.propTypes = {
  policy: PropTypes.shape({
    id: PropTypes.number,
    base: PropTypes.object,
    endosos: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  loginIdToken: PropTypes.string.isRequired,
  initialVigencia: PropTypes.number,
};

const mapStateToProps = state => ({
  loginIdToken: state.login.id_token,
});

export default connect(mapStateToProps)(CreditPolicyDetailVigencias);
